import { ProductPackageApiDto } from '@lx/shared/api/models';

export const ProductPackageEnum = ProductPackageApiDto;
export type ProductPackage = ProductPackageApiDto;
